import Home from './home/home';
import About from './about/about';
import Refinance from './refinance/refinance.module'
import Purchase from './purchase/purchase.module';
import Sale from './sale/sale.module';
import Steps from './steps/steps';
import Calculator from './calculator/calculator.module';

let componentModule = angular.module('app.components', [
  Home,
  About,
  Refinance,
  Purchase,
  Sale,
  Steps,
  Calculator
])

.name;

export default componentModule;



// WEBPACK FOOTER //
// ./client/app/components/components.js